/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const data = {
    img: "https://i.ibb.co/5MK8Pmm/rp-owned-asset-750-700.png",
    title: "Owned Assets Description",
    description:
      "In this section you can view the assets that are owned by you / your organisation",
    meta: [
      {
        key: "-",
        value: "Read More",
      },
      {
        key: "•",
        value: "Owned Assets - Grid View",
        path: "/owned-assets",
      },
      {
        key: "•",
        value: "Showcased Assets - Grid View",
        path: "/showcased-assets",
      },
      {
        key: "•",
        value: "Owned Assets - Table View",
        path: "/owned-assets-table",
      },
      // {
      //   key: "• Date & Time of User action",
      //   value: "",
      // },
      // {
      //   key: "• Location",
      //   value: "",
      // },
      // {
      //   key:
      //     "The Brand protection also provides user scans done on the product batches which are not on the Shelf anymore.",
      //   value: "",
      // },
    ],
    // buttons: [
    //   {
    //     key: "edit",
    //     title: "Edit",
    //   },
    // ],
  };